<template>
  <article class="popup popup-change-owner">
    <header class="header popup-top">
      <h2 class="title">
        {{$t('popups.thingsRightsControl.changeOwnerTitle')}}
      </h2>
      <div class="popup-top_btns">
        <close-btn class="static"></close-btn>
      </div>
    </header>
    <form class="contents change-form" @submit.prevent="">
      <label v-if="!confirm"
             class="input-cont input-cont_small">
        <p class="label">
          {{$t('popups.thingsRightsControl.oldOwner')}}
        </p>
        <input type="text" :value="ownerName" disabled readonly>
      </label>
      <div class="select-cont"
           v-if="!confirm" >
        <p class="label">
          {{$t('popups.thingsRightsControl.newOwner')}}
        </p>
        <v-select :options="usersArr"
                  :clearable="false"
                  :searchable="false"
                  :filterable="false"
                  :close-on-select="true"
                  :select-on-tab="true"
                  v-model="user"
                  label="name"></v-select>
      </div>
      <label v-if="!confirm"
             class="check-cont check-cont_small">
        <input type="checkbox" v-model="saveThing">
        <p class="check-label">{{$t('popups.thingsRightsControl.changeSave')}}</p>
      </label>
      <div v-if="confirm"
           class="confirm">
        {{$t('things.changeDesc')}}
      </div>
      <div class="btn-cont" v-if="!confirm">
        <button type="button"
                @click="closeAll"
                class="btn btn-transparent_red">{{$t('btns.cancel')}}</button>
        <button type="button"
                :disabled="!user"
                class="btn btn-transparent_blue"
                @click="goToConfirm">
          {{$t('btns.accept')}}
        </button>
      </div>
      <div class="btn-cont" v-else>
        <button type="button"
                @click="backConfirm"
                :disabled="loading"
                class="btn btn-transparent_red">{{$t('btns.cancel')}}</button>
        <button type="submit"
                @click="changeRole"
                :class="{'loading': loading}"
                :disabled="loading"
                class="btn btn-transparent_blue">
          {{$t('btns.accept')}}
        </button>
      </div>
    </form>
  </article>
</template>

<script>
  import closeBtn from '../../closeBtn'
  import {popups} from "../../../../mixins/popups";
  import {mapState, mapActions} from 'vuex'
  import {addThing} from "../../../../mixins/things/addThings";
  import {tokenAndRoute} from "../../../../mixins/utils/tokenAndRoute";
  import {toFormData} from "../../../../mixins/utils/toFormData";

  export default {
    name: 'changeOwner',
    mixins: [popups, addThing, tokenAndRoute, toFormData],
    components: {
      closeBtn
    },
    data() {
      return {
        user: '',
        saveThing: false,
        confirm: false,
        loading: false
      }
    },
    computed: {
      ...mapState({
        thing: state => state.things.device,
        activeSectionThings: state => state.things.activeSectionThings
      }),

      ownerName() {
        return `${this.thing.owner.user.first_name} ${this.thing.owner.user.second_name ? this.thing.owner.user.second_name : ''}`
      }
    },
    methods: {
      ...mapActions({
        updateThing: 'things/updateDevice',
        setPermissions: 'things/setPermissions',
        getOwnedThings: 'things/getDevices',
       // getAssignedThings: 'things/getAssignedDevices'
      }),
      goToConfirm() {
        this.confirm = true
      },
      backConfirm() {
        this.confirm = false
      },
      async changeRole() {
        this.loading = true;
        let data = {
         // access_token: this.token,
          device_id: this.thing.id,
          owner_role_id: this.user.primary_role_id
        };
        let formData = this.toFormData(data);
        if (this.saveThing) {
          let rightsData = {
           // access_token: this.token,
            object_id: this.thing.id,
            object_name: 'device',
            value: 3,
          };
          //разделяем на эмейлы и роли
          let emails = [];
          let roles = this.thing.permissions.filter(item => {
            if (!item.role.owner) {
              return item
            } else {
              emails.push(item);
            }
          });

          //собираем в строки
          emails = emails.map(item => {
            return item.role.owner.contacts.email
          });
          //добавляем текущего
          emails.push(this.thing.owner.contacts.email);
          emails = emails.join(',');

          rightsData.emails = emails;

          roles = roles.map(item => {
            return item.role.id
          }).join(',');

          if (roles) {
            rightsData.roles_ids = roles
          };

          await this.setPermissions({data: rightsData, token: this.token});
        };

        await this.updateThing({
          data: formData,
          token: this.token,
        }).then(async res => {
          this.$router.push('/things');
        });
        this.getOwnedThings({token: this.token})
        this.loading = false;
        this.closeAll();
      }
    }
  }
</script>


<style lang="scss" scoped>
  .popup-change-owner {
    padding: 0;
    width: 420px;
  }

  .header {
    padding: 30px;
    margin-bottom: 30px;
  }

  .content {
    padding: 30px;
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .big {
    font-family: $msb;
    font-size: 21px;
    letter-spacing: .15px;
    margin-bottom: 20px;
  }

  .small {
    font-family: $mr;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .btn-cont {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 30px;

    .btn {
      width: calc(50% - 10px);
    }
  }

  .select-cont, .input-cont {
    margin-bottom: 20px;
  }

  .confirm {
    font-family: $mr;
    font-size: 16px;
    text-align: center;
  }
</style>
